import axios from 'axios'
import {API_URL} from '../../../tenant/apiBase'

/**
 * Mart v2: a shop supplier's Jazari pickers (JazariUserController). Admin only; every picker
 * works at one of the supplier's shops, one shop per branch.
 */
export interface JazariUser {
  user_id: number
  username: string
  firstname: string
  lastname: string
  email: string
  phone: string
  status: boolean
  date_added: string
  fulfillment_center_id: number
  branch_id: number
  branch_name: string
}

export interface CreateJazariUser {
  firstname: string
  lastname: string
  email: string
  phone: string
  fulfillment_center_id: number | null
}

const URL = `${API_URL}/api/partner-portal/jazari-users`

const headers = (token?: string, language?: string) => ({token: token || '', language: language || 'en'})

export const getJazariUsers = (token?: string, language?: string): Promise<JazariUser[]> =>
  axios.get(URL, {headers: headers(token, language)}).then((r) => r.data?.data ?? [])

export const createJazariUser = (user: CreateJazariUser, token?: string, language?: string): Promise<any> =>
  axios.post(URL, user, {headers: headers(token, language)}).then((r) => r.data)

export const setJazariUserStatus = (id: number, status: boolean, token?: string, language?: string): Promise<any> =>
  axios.put(`${URL}/${id}/status`, {status}, {headers: headers(token, language)}).then((r) => r.data)

export const setJazariUserBranch = (id: number, fulfillmentCenterId: number, token?: string, language?: string): Promise<any> =>
  axios
    .put(`${URL}/${id}/branch`, {fulfillment_center_id: fulfillmentCenterId}, {headers: headers(token, language)})
    .then((r) => r.data)

export const setJazariUserPhone = (id: number, phone: string, token?: string, language?: string): Promise<any> =>
  axios.put(`${URL}/${id}/phone`, {phone}, {headers: headers(token, language)}).then((r) => r.data)
